// @ts-nocheck
import Content from "./content";
import { _ } from "~/i18n";
import { node, text } from "~/util/dom";
import { createDeepLTranslate } from "~/ui/deepl";
import { store } from "~/state/store";

/**
 * @class Vytváří položku obsahu vizitky - textový popis
 * @private
 */
export default class Description extends Content {
	_build() {
		this._dom.container.classList.add("content-description");

		const data = typeof this._data === "string" ? this._data : this._data.text;
		const { source } = store.getState().detail;
		const span = node("span");

		const deepl = ["coor", "closure"].indexOf(source) === -1
			? createDeepLTranslate({
				text: data,
				lang: this._options.lang,
				container: span,
			}, ["traff", "di"].indexOf(source) === -1 ? "detail" : "trafficPoi")
			: null;

		if (source === "foto" || source === "ffoto") {
			span.appendChild(text(data));
			this._dom.container.appendChild(span);
			deepl && this._dom.container.appendChild(deepl);

			return;
		}

		span.innerHTML = data;

		this._dom.container.appendChild(span);

		if (this._data.source) {
			this._dom.container.appendChild(text(" "));
			this._dom.container.appendChild(node("a", { innerHTML: this._data.source.text, href: this._data.source.url, target: "_blank" }));
		}

		deepl && this._dom.container.appendChild(deepl);

		this._hiddenNodes = [];
		this._hideMore();
	}

	/**
	 * Nalezne kontejner obsahujici dvousty znak; za nim ostatni schova a prida rozplusnuti.
	 */
	_hideMore() {
		let str = 0;
		const limit = 200;
		let container = null;
		const nodeNames = ["p", "div", "li"];

		const all = this._dom.container.getElementsByTagName("*");

		for (let index = 0; index < all.length; index++) { /* projit vsechny uzly */
			const element = all[index];

			for (let childIndex = 0; childIndex < element.childNodes.length; childIndex++) { /* projit vsechny potomky */
				let child = element.childNodes[childIndex];

				if (child.nodeType !== 3) {
					continue;
				} /* bereme jen text */

				str += child.nodeValue.trim().length;
				if (str >= limit) { /* nasli jsme zlom */
					while (child !== this._dom.container) { /* nahoru nez najdeme rodice */
						child = child.parentNode;
						if (nodeNames.indexOf(child.nodeName.toLowerCase()) !== -1 && !container) {
							container = child;
						}
					}
					break;
				}
			}
		}

		if (!container) {
			return;
		}

		/* poschovavat vse co je za containerem */
		while (container !== this._dom.container) {
			while (container.nextSibling) {
				container = container.nextSibling;
				if (container.nodeType !== 1) {
					continue;
				}
				this._hiddenNodes.push(container);
				container.style.display = "none";
			}
			container = container.parentNode;
		}

		if (!this._hiddenNodes.length) {
			return;
		}

		const show = node("a", { href: "#", innerHTML: _("detail.content.description") });

		this._dom.container.appendChild(show);
		this._ec.push(JAK.Events.addListener(show, "click", this, "_more"));
	}

	_more(event, elm) {
		JAK.Events.cancelDef(event);
		elm.style.display = "none";
		while (this._hiddenNodes.length) {
			this._hiddenNodes.shift().style.display = "";
		}
	}
}
